import GeoJSONGeometry from '../geojson-geometry/geojson-geometry.model';

export default class GeoJSONPoint<T> {
    public type = 'Feature';
    public geometry: GeoJSONGeometry<number[]> = new GeoJSONGeometry();
    public properties: T;
    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    toJson() {
        return {
            type: this.type,
            geometry: this.geometry,
            properties: this.properties
        };
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.type) {
            this.type = model.type;
        }
        if (model.geometry) {
            this.geometry = new GeoJSONGeometry(model.geometry);
        }
        if (model.properties) {
            this.properties = model.properties;
        }
    }

    apiObject() {
        return {
            type: this.type,
            geometry: this.geometry,
            properties: this.properties
        };
    }
}
